import { FETCH_FAQS, FETCH_FAQ_CATEGORIES } from './constants'

const initialState = {
  faqs: [],
  categories: [],
  isFetching: false,
  isFetchingFaqs: false
}

export default function FaqListReducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_FAQS.REQUEST: {
      return {
        ...state,
        isFetchingFaqs: true
      }
    }
    case FETCH_FAQS.SUCCESS: {
      return {
        ...state,
        isFetchingFaqs: false,
        faqs: action.faqs
      }
    }
    case FETCH_FAQ_CATEGORIES.REQUEST: {
      return {
        ...state,
        isFetching: true
      }
    }

    case FETCH_FAQ_CATEGORIES.SUCCESS: {
      return {
        ...state,
        isFetching: false,
        categories: action.categories
      }
    }
    default: {
      return state
    }
  }
}
